import { nanoid } from 'nanoid';
import { Node } from 'slate';

import { ELEMENT_QUESTION_LIST, ELEMENT_QUESTION_LIST_ITEM } from './plugins/QuestionListPlugin.types';

function createQuestionListNode() {
  return {
    id: nanoid(),
    type: ELEMENT_QUESTION_LIST,
    children: [
      {
        type: ELEMENT_QUESTION_LIST_ITEM,
        children: [{ text: '' }],
      },
      {
        type: ELEMENT_QUESTION_LIST_ITEM,
        children: [{ text: '' }],
      },
    ],
  } as Node;
}

export const questionListTransforms = {
  createQuestionListNode,
};
